import { __makeTemplateObject } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Currency } from '../currency/Currency.js';
import { Text } from '../text/Text.js';

var Price = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ProductRRP__Price",
  componentId: "sc-d7twce-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: line-through;\n  margin: 0 4px;\n"], ["\n  text-decoration: line-through;\n  margin: 0 4px;\n"])));
var ProductRRP = function (_a) {
  var amount = _a.amount;
  return React__default.createElement(Price, {
    fontFamily: "heading",
    letterSpacing: "tight",
    fontSize: "0.75em",
    color: "deal",
    fontWeight: "700"
  }, React__default.createElement(Currency, {
    amount: amount,
    includeFraction: false
  }));
};
var templateObject_1;

export { ProductRRP as default };
//# sourceMappingURL=ProductRRP.js.map
